import React, { useEffect, useState } from "react";
import "./CustomersList.scss";
import TableComponent from "../../components/TableComponent/TableComponent";
import ToastHelper from "../../services/ToastHelper";
import { GET_CUSTOMERS_LIST } from "../../utils/apiPath";
import { postApi } from "../../utils/apiServices";

const CustomersList = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });

  const columns = [
    {
      title: "Sl No",
      dataIndex: "name",
      sorter: false,
      render: (_, __, index) =>
        (pagination?.current - 1) * pagination?.pageSize + (index + 1),
    },
    {
      title: "Name",
      dataIndex: "name",
      sorter: false,
    },
    {
      title: "Email",
      dataIndex: "email",
      sorter: false,
    },
    {
      title: "Phone Number",
      dataIndex: "phoneNumber",
      sorter: false,
    },
    {
      title: "Orders Count",
      dataIndex: "ordersCount",
      sorter: false,
    },
    {
      title: "Amount Spent",
      dataIndex: "totalAmountSpent",
      sorter: false,
    },
  ];

  const fetchCustomers = async (parentId) => {
    const payload = {
      pageIndex: pagination.current - 1,
      pageSize: pagination.pageSize,
      searchString: "",
    };
    setLoading(true);
    try {
      const res = await postApi(GET_CUSTOMERS_LIST, payload);

      if (res?.data?.length !== 0) {
        setData(res?.data);
        setPagination((prev) => ({ ...prev, total: res?.totalRecords }));
        return res;
      } else {
        ToastHelper.error("Something went wrong. Please try again.");
      }
    } catch (err) {
      // ToastHelper.error(
      //   "Failed to connect to the server. Please try again later."
      // );
    } finally {
      setLoading(false);
    }
    return null;
  };

  useEffect(() => {
    fetchCustomers();
  }, [pagination.current, pagination.pageSize]);

  const handleTableChange = (newPagination) => {
    setPagination(newPagination);
  };

  return (
    <div className="customers">
      <div className="customers_container">
        <div className="customers_header">
          <div className="customers_header_left">
            <span className="active">Customers list</span>
          </div>
        </div>
        <TableComponent
          columns={columns}
          data={data}
          pagination={pagination}
          loading={loading}
          onTableChange={handleTableChange}
        />
      </div>
    </div>
  );
};

export default CustomersList;
